import {
  provideDarkTheme,
  SOFTLINE_CONFIG_DEFAULT_THEME,
  SOFTLINE_CONFIG_THEMES,
} from '@softline/application';
import { CustomerConfig } from 'apps/softapps/src/customer-config.type';

export const customerConfig: CustomerConfig = {
  version: '0.0.0',
  id: 'at.softline.ksk.softline',
  name: 'Hagebau KSK Softline',
  providers: [
    { provide: SOFTLINE_CONFIG_DEFAULT_THEME, useValue: 'hagebau' },
    provideDarkTheme(false),
    {
      provide: SOFTLINE_CONFIG_THEMES,
      useValue: {
        key: 'hagebau',
        name: 'Hagebau',
      },
      multi: true,
    },
  ],
};
